import { render, staticRenderFns } from "./PayrollDeclarationList.vue?vue&type=template&id=d8c50854&scoped=true&"
import script from "./PayrollDeclarationList.vue?vue&type=script&lang=js&"
export * from "./PayrollDeclarationList.vue?vue&type=script&lang=js&"
import style0 from "./PayrollDeclarationList.vue?vue&type=style&index=0&id=d8c50854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c50854",
  null
  
)

export default component.exports